import { useMemo } from 'react'
import { Provider as UrqlProvider } from 'urql'

import { useStore } from '@app/store'
import { makeClient } from '@graphql/client'

const GraphqlProvider = ({ children }) => {
  const addObject = useStore.use.addObject()
  const deleteObject = useStore.use.deleteObject()
  const bulkAdd = useStore.use.bulkAdd()
  const bulkDelete = useStore.use.bulkDelete()

  const client = useMemo(
    () =>
      makeClient({
        addObject,
        deleteObject,
        bulkAdd,
        bulkDelete
      }),
    [addObject, deleteObject, bulkAdd, bulkDelete]
  )

  return <UrqlProvider value={client}>{children}</UrqlProvider>
}

export default GraphqlProvider
